/**
 * @internal
 */
import { useEffect } from 'react';
import framesync from 'framesync';
/**
 * Subscribe to multiple MotionValues / MutableValues and trigger a single "onChange" event
 */
const useOnValuesChange = (values, handle, { initial = false } = {}) => {
    useEffect(() => {
        const handlers = () => {
            const latestValues = values.map((value) => value.get());
            handle(...latestValues);
        };
        const update = () => {
            framesync.update(handlers, false, true);
        };
        const subscriptions = values.map((value) => {
            return value.on('change', update);
        });
        if (initial) {
            update();
        }
        return () => {
            subscriptions.forEach((unsubscribe) => unsubscribe());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...values, handle]);
};
export default useOnValuesChange;
